import Exercises from '@/pages/admin/Exercises';

/** Biblioteca do personal: exercícios globais + próprios (scope=all), cria os próprios. */
export default function TrainerLibrary() {
  return <Exercises mode="library" />;
}
